// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__LkvAu","footer":"ModalInfo_footer__sb--a"};